import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState
} from './roles.action';
import { Role } from './roles.model';

export interface RoleRecordsState {
    listData: Role[];
    singleData: Role;
    loading: boolean;
    error: any;
}

export const initialState: RoleRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
};


export const roleRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData }) => {
        return { ...state, listData: listData, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
    // addRecord
    // addRecordFailure
    // updateRecord
    // updateRecordSuccess
    // updateRecordFailure
    // deleteRecord
    // deleteRecordSuccess
    // deleteRecordFailure

    // on(addRecordSuccess, (state, { newData }) => {
    //     return { ...state, UserListdata: [newData, ...state.UserListdata], error: null };
    // }),

    // on(updateRecordSuccess, (state, { updatedData }) => {
    //     return { ...state, UserListdata: state.UserListdata.map((UserListdata) => UserListdata.id === updatedData.id ? updatedData : UserListdata), error: null };
    // }),

    // on(deleteRecordSuccess, (state, { id }) => {
    //     return { ...state, UserListdata: state.listData.filter((UserListdata) => UserListdata.id !== id), error: null }
    // }),
);